import { Outlet } from 'react-router-dom';
import { AuthProvider } from '../context/AuthProvider';
import ClarityAnalytics from '../context/ClarityAnalytics';
import { useEffect } from 'react';
import TagManager from '@sooro-io/react-gtm-module';

const RootLayout = () => {
  useEffect(() => {
    // Only initialize GTM in production
    if (process.env.NODE_ENV === 'production') {
      const tagManagerArgs = {
        gtmId: process.env.REACT_APP_GTM_ID || '',
        dataLayer: {
          platform: 'web',
          environment: 'production',
        },
      };

      TagManager.initialize(tagManagerArgs);
    }
  }, []);

  return (
    <AuthProvider>
      <ClarityAnalytics />
      <main>
        <Outlet />
      </main>
    </AuthProvider>
  );
};

export default RootLayout;
